import { Injectable, Injector } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { UserDao } from '@app/dao/user/user.dao';
import * as _ from 'lodash';
import { UserEmail } from '@app/forms/subscription/definition/interface/subscription';
import FormGroupArray from '../../services/FormGroupArray';
import { take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  userId;
  constructor(
    protected formConstructor: PrFormConstructor,
    protected injector: Injector,
  ) {
    super(formConstructor);
    injector
      .get(UserDao)
      .getAuthentified()
      .pipe(take(1))
      .subscribe(user => {
        this.userId = user.id;
      });
  }

  generateForm(entity: UserEmail) {
    let options: AbstractControlOptions = {};
    const form = this.formBuilder.group(
      {
        ownerId: [entity.ownerId],
        receivePreContractElementsEmail: [
          entity && entity?.receivePreContractElementsEmail
            ? entity.receivePreContractElementsEmail
            : false,
          [Validators.requiredTrue],
        ],
      },
      options,
    );

    return form;
  }
  generate(entity: UserEmail[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      ownerId: this.userId,
    });
  }
  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }
  extract() {
    return this.form.value.owners;
  }
}
